import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "row items-center q-gutter-md" }
const _hoisted_3 = { class: "col" }

import DisplayProperty from 'components/global-common/DisplayProperty.vue';
import ToggleButtonGroup from 'components/global-common/ToggleButtonGroup.vue';
import { watch } from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import {
  createTogglePaneList,
  MAX_TOGGLE,
  SEX_OPTIONS,
} from './common-constants';
import { useLayoutStore } from 'stores/layout-store';
import { storeToRefs } from 'pinia';
import DropDown from 'components/global-common/DropDown.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperHeader',
  setup(__props) {

const layoutStore = useLayoutStore();
const { layoutMode } = storeToRefs(layoutStore);
const grouperStore = useGrouperStore();
const {patient, dischargeStatus, getDischargeStatuses, readOnly, sex} = storeToRefs(grouperStore);

watch([ sex, dischargeStatus ], 
    ([ newSex, newDischargeStatus ],
    [ oldSex, oldDischargeStatus ]) => {

  // Only recalculate if sex or discharge status has changed
  if ((!newSex || !oldSex || newSex.value === oldSex.value) 
    && (newDischargeStatus?.code === oldDischargeStatus?.code || (!newDischargeStatus && !oldDischargeStatus))) {
    return;
  }

  grouperStore.recalculateNeeded();
});

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "grouper-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(layoutMode) === _unref(GrouperLayoutMode).fullScreen)
            ? (_openBlock(), _createBlock(_component_q_toolbar_title, {
                key: 0,
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(patient)?.name), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(DropDown, {
            options: _unref(SEX_OPTIONS),
            modelValue: _unref(sex),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sex) ? (sex).value = $event : null)),
            disable: _unref(readOnly),
            "read-state": true,
            "option-label": "label",
            "option-value": "value",
            label: "Sex",
            "iodine-class-name": "sex"
          }, null, 8, ["options", "modelValue", "disable"]),
          _createVNode(DropDown, {
            modelValue: _unref(dischargeStatus),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dischargeStatus) ? (dischargeStatus).value = $event : null)),
            options: _unref(getDischargeStatuses),
            disable: _unref(readOnly),
            "read-state": true,
            "option-label": "description",
            "option-value": "code",
            label: "Discharge Status",
            "iodine-class-name": "discharge-status",
            "popup-content-class": "discharge-status-popup",
            "io-clearable": ""
          }, null, 8, ["modelValue", "options", "disable"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(DisplayProperty, {
              label: "Discharge Date",
              value: (_unref(patient)?.dischargeDate as string)
            }, null, 8, ["value"])
          ]),
          (_unref(layoutMode) === _unref(GrouperLayoutMode).fullScreen)
            ? (_openBlock(), _createBlock(ToggleButtonGroup, {
                key: 1,
                "toggle-button-data": _unref(createTogglePaneList)().value,
                "max-toggle": _unref(MAX_TOGGLE)
              }, null, 8, ["toggle-button-data", "max-toggle"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})